export type RetryInterval = {
  days: number;
  hours: number;
  minutes: number;
};

export type NodeItem = {
  id: string;
  label?: string;
  code?: string;
  value?: string | string[] | number | number[] | boolean | null;
  errorId?: string;
  settingId?: string;
  action?: string;
  maxRetries?: number;
  retryInterval?: RetryInterval;
  isAllSelected?: boolean;
};

export type DataItems = {
  items: NodeItem[];
};

export type ParentNode = {
  id: string;
  type: string;
  data: DataItems;
};

export type DefaultNodeData = DataItems;
export type ErrorNodeData = DataItems;
export type SettingsNodeData = DataItems;
export type ConditionalNodeData = DataItems;
export type RecurringActionNodeData = DataItems;

export type ConnectorType = 'source' | 'target';

// Start: Component specific types
export type TestGroupOptions = {
  title: string;
  group: number;
};

export const isDeclineRecurringAction = (action: string) => {
  return action === 'decline';
};

export const IntervalValues = {
  days: 'days',
  hours: 'hours',
  minutes: 'minutes',
};
